
gsap.registerPlugin(ScrollTrigger);
const isOurStory = location.pathname.includes('/pages/our-story');

function animateTextSplit(direction,el,staggerVal=0.05,delayVal,onScroll=true,triggerEl,startVal=80,endVal=30,markersVal=false){
    try{
    const titles = document.querySelectorAll(el);
if(!titles){
    return
}
    titles.forEach(title=>{

    
    text = title.textContent;
    title.classList.add(`text-split-parent-${direction.toLowerCase()}`);
    
    title.textContent = "";
    
    text.split(" ").forEach(word => {
        const wordSpan = document.createElement("span");
        wordSpan.style.whiteSpace = "nowrap"; // prevents breaking mid-word
    word.split("").forEach(char => {
        const charSpan = document.createElement("span");
        charSpan.textContent = char;
        wordSpan.appendChild(charSpan);
    });

    const space = document.createTextNode(" "); // adds space between words
    title.appendChild(wordSpan);
    title.appendChild(space);
});
    const letters = title.querySelectorAll("span");
    if(onScroll){
        gsap.to(letters, {
            y: 0,
            x:0,
            opacity: 1,
            ease: "power3.out",
            stagger: staggerVal,
            scrollTrigger: {
                trigger: triggerEl,
                start: `top ${startVal0}%`,
                end: `top ${endVal}%`,
                markers: markersVal,
                scrub: 1,
            }
        });
        
    }else{
        gsap.to(letters ,{
            y: 0,
            x:0,
            opacity:1,
            delay: delayVal,
            duration: .5,
            ease: "power3.out",
            stagger: staggerVal,
        });
    }
    })
}catch(e){
    console.error(e.message);
      
}
}

function clipPathAnimate(direction,el,delayVal,onScroll=true,triggerEl,startVal=80,endVal=30,markersVal=false){
    try{
    const items = document.querySelectorAll(el);
    if(!items){
    return
}
    items.forEach(item => {
        item.classList.add(`clipPath-from-${direction}`);
         gsap.to(el, {
            clipPath:"inset(0% 0% 0% 0%)",
            ease: "power1.out",
            scrollTrigger: {
                trigger: triggerEl,
                start: `top ${isOurStory ? start-100 : start}%`,
            end: `top ${isOurStory ? start-100 : end}%`,
                markers: markersVal,
                scrub: true,
            }
        });
    });

    }catch(e){
    console.error(e.message);
    }
}


// -------------- password page animations --------------


function fadeUp(className,opVal,yVal,start,end,markVal){
    const El = document.querySelector(className);
    gsap.from(El, {
        opacity:opVal,
        y:yVal,
        ease: "power1.out",
        scrollTrigger: {
            trigger:El ,
            start: `top ${isOurStory ? start-100 : start}%`,
            end: `top ${isOurStory ? start-100 : end}%`,
            markers: markVal,
            scrub: 2,
        }
    });
}
// -------------- password page animations --------------



document.addEventListener("DOMContentLoaded", function () {
    
// ------- split animation guide -------
// animateTextSplit(direction(x,y,xy,o)),el, staggerVal = 0.05,delay, onScroll = true,delay, triggerEl , startVal = 80, endVal = 30, markersVal = false)

// animateTextSplit("xy",".hero_main .hero_content h3",0.025,0,false)
// animateTextSplit("o",".hero_main .hero_content p",0.007,0.65,false)
// animateTextSplit("xy",".cont_main h3",0.05,0,true,".col_main .cont_main h3",95,70,false)
animateTextSplit("y",".footer-top-left h3",0.04,0,true,".footer-top-left h3",95,70,false)
animateTextSplit("x2",".footer-top-left p",0.04,0,true,".footer-top-left p",80,45,false)
animateTextSplit("o",".main_about p",0.03,0,true,".main_about p",97,50,false)
// animateTextSplit("o",".section_r p",0.03,0,true,".section_r p",197,150,false)
// animateTextSplit("y",".section_l p",0.03,0,true,".section_l p",197,150,false)
// animateTextSplit("y",".section_bottom_content p",0.03,0,true,".section_bottom_content p",197,150,false)
// animateTextSplit("o",".about-section2-box p",0.03,0,true,".about-section2-box p",197,150,false)
// animateTextSplit("x",".sl-desc-div p",0.03,0,true,".sl-desc-div p",197,150,false)
// animateTextSplit("xy",".our-community-content-information p",0.01,0,true,".our-community-content-information p",197,150,false)
// animateTextSplit("y",".sl-img-desc p",0.03,0,true,".sl-img-desc p",197,150,false)
// animateTextSplit("y",".sl-img-desc-p2 p",1.04,197 * 0.03, true,".sl-img-desc-p2 p",95,100,false)


// ------- split animation guide -------


// ------- clipPath animation guide -------
// animateTextSplit(direction(l,r,tl,tr,bl,br)),el,delay, onScroll = true,delay, triggerEl , startVal = 80, endVal = 30, markersVal = false)
clipPathAnimate("r",".featured_content h3",0,true,".featured_content h3",70,60,false)
clipPathAnimate("l",".featured-shoplink",0,true,".featured-shoplink",95,75,false)
clipPathAnimate("r",".footer-bottom a",0,true,".footer-bottom a",100,89,false)
// clipPathAnimate("br",".section_bottom_content h4",0,true,".section_bottom_content h4",180,169,false)
// clipPathAnimate("r",".sl-img-desc h6",0,true,".sl-img-desc h6",180,169,false)
// clipPathAnimate("r",".sl-img-desc h1",0,true,".sl-img-desc h1",180,169,false)
// clipPathAnimate("bl",".about-section2-box h1",0,true,".about-section2-box h1",180,169,false)
// clipPathAnimate("r",".sl-desc-div h1",0,true,".sl-desc-div h1",180,169,false)
// clipPathAnimate("r",".our-community-content-information span",0,true,".our-community-content-information span",180,169,false)
// clipPathAnimate("bl",".our-community-content-information h1",0,true,".our-community-content-information h1",180,169,false)

// ------- clipPath animation guide -------



// const heroImg = document.querySelector(".hero_img");

// gsap.to(heroImg, {
//     scale:1.8,
//     ease: "power1.out",
//     scrollTrigger: {
//         trigger: ".hero-shoplink",
//         start: "top 78%",
//         end: "top 0%",
//         markers: false,
//         scrub: 1,
//     }
// });
// const colImg = document.querySelector(".col_img");

// gsap.to(colImg, {
//     filter:"grayscale(0)",
//     ease: "power1.out",
//     scrollTrigger: {
//         trigger: colImg,
//         start: "top 50%",
//         end: "top 0%",
//         markers: false,
//         scrub: 1,
//     }
// });


// cards

function productCardRender(groupEL){
    const productCards = document.querySelectorAll(groupEL);
    const cardsArray = Array.from(productCards);
    for (let i = 0; i < cardsArray.length; i += 3) {
        const group = cardsArray.slice(i, i + 3);
        
        gsap.from(group, {
            opacity: 0,
            x: 40,
            ease: "power1.out",
            stagger: 0.3, 
            scrollTrigger: {
                trigger: group[0], 
                start: "top 190%",
                end: "top 150%",
                scrub: 1,
                markers: false,
            }
        });
    }
}

productCardRender(".product-grid .card-wrapper")
// cards



// -------------- password page animations --------------


fadeUp(".section_l",0,150,"200","160",false)
// fadeUp(".section_l",0,150,"100","60",false)
fadeUp(".section_r p",0,200,"220","190",false)
// fadeUp(".logo-box-section3",0,200,"200","198",false)


fadeUp(".our-community-content-img",0,150,"205","200",false)

// mobile
if(innerWidth<950){
    fadeUp(".our-community-content-information>span",0,100,"210","200",false)
    fadeUp(".our-community-content-information>h1",0,100,"210","200",false)
    fadeUp(".our-community-content-information>p",0,100,"210","200",false)
    fadeUp(".about-section2-box h1",0,300,"260","250",false)
    fadeUp(".about-section2-box p",0,200,"240","225",false)
    fadeUp(".sl-img-desc h6",0,220,"230","225",false)
    fadeUp(".sl-img-desc h1",0,230,"230","225",false)
    fadeUp(".sl-img-desc p",0,230,"235","228",false)
    fadeUp(".sl-img-desc .sl-img-desc-p2",0,220,"235","228",false)
    fadeUp(".sl-desc-div h1",0,230,"240","230",false)
    fadeUp(".sl-desc-div p",0,220,"240","230",false)
    fadeUp(".section_bottom_content h4",0,170,"240","230",false)
    fadeUp(".section_bottom_content p",0,150,"240","230",false)
    gsap.from(".logo-box-section3", {
        scale:0.2,
        opacity:0,
        ease: "power1.out",
        scrollTrigger: {
            trigger: ".logo-box-section3",
             start: `top ${isOurStory ? 110 : 210}%`,
            end: `top ${isOurStory ? 82 : 182}%`,
            markers: false,
            scrub: 1,
        }
    });
    
    
}else{
    fadeUp(".our-community-content-information>span",0,150,"205","200",false)
    fadeUp(".our-community-content-information>h1",0,120,"210","200",false)
    fadeUp(".our-community-content-information>p",0,140,"230","200",false)
    fadeUp(".about-section2-box h1",0,330,"240","235",false)
    fadeUp(".about-section2-box p",0,200,"222","217",false)
    fadeUp(".sl-img-desc h6",0,170,"220","210",false)
fadeUp(".sl-img-desc h1",0,170,"220","210",false)
fadeUp(".sl-img-desc p",0,150,"220","210",false)
fadeUp(".sl-img-desc .sl-img-desc-p2",0,150,"220","210",false)
fadeUp(".sl-desc-div h1",0,200,"215","210",false)
fadeUp(".sl-desc-div p",0,200,"220","215",false)
fadeUp(".section_bottom_content h4",0,200,"240","225",false)
fadeUp(".section_bottom_content p",0,220,"230","225",false)
    gsap.from(".logo-box-section3", {
        scale:0.2,
        opacity:0,
        ease: "power1.out",
        scrollTrigger: {
            trigger: ".logo-box-section3",
            start: `top ${isOurStory ? 110 : 210}%`,
            end: `top ${isOurStory ? 30 : 130}%`,
            markers: false,
            scrub: 1,
        }
    });

}
// mobile


// -------------- password page animations --------------




// --- DOM LOADED ----
});